import React, { useState, useEffect, useContext, useRef } from 'react';
import {AppContext} from '../../application/provider';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup} from 'reactstrap';
import "./ModalCrearUsuario.css";
import PlanillaService from "../../axios_services/planilla.service";
import ArchivosService from "../../axios_services/archivos.service";
import Loader from '../../components/Loader/Loader'; 
import {FileMinus, Upload, Save, DollarSign } from "lucide-react";


function ModalEstadoPago({isOpen}) {

    const [state,setState] = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [monto_transaccion, setMontoTransaccion] = useState('');
    const [monto_diferido, setMontoDiferido] = useState(0);
    const [periodo_pago, setPeriodoPago] = useState('');
    const [estado_pago, setEstadoPago] = useState('');
    const [fecha_pago, setFechaPago] = React.useState('');
    const [file, setFile] = React.useState(null);
    const fileRef = useRef(null);
    const [estados_pago] = useState(state.catalogos.tipos.filter(t => {return t.categoria_id == 32}));


    const editarEstadoPago = async () => {
        console.log(state.cargo_pago.periodo_pago)

            try {




                await PlanillaService.editarEstadoPago(
                    state.user?.usuario_id,
                    state.cargo_pago.planilla_id, 
                    estado_pago, 
                    periodo_pago, 
                    null, // Passing null here because we'll upload separately if needed
                    [1, 3].includes(Number(estado_pago)) ? null : (fecha_pago || null)
                );

                if (file) {
                    await ArchivosService.guardarReciboPorHonorarios(
                        file, 
                        state.cargo_pago.usuario_id, 
                        state.user.usuario_id, 
                        state.cargo_pago.periodo_pago
                    );
                }

                cerrarModal();
                alert("Registro actualizado con éxito");
                setState(prevState => ({
                    ...prevState,
                    isUpdated: true,
                }));
            } catch (error) {
                if (error.response && error.response.data && error.response.data.error) {
                    alert(`Error: ${error.response.data.error}`);

                } else {
                    alert("Hubo un error al actualizar el registro. Intenta nuevamente.");
                }
            }
    };


    React.useEffect(() => {
        if(state.modalEstadoPago === true){
            setEstadoPago(state.cargo_pago.estado_pago_id);
            setMontoTransaccion(state.cargo_pago.total_pagar);
            setPeriodoPago(state.cargo_pago.periodo_pago);
            setFechaPago(state.cargo_pago.fecha_pago || '');
        }   
    }, [state.modalEstadoPago]);

    React.useEffect(() => {
        if ([1, 3].includes(Number(estado_pago))) {
            setFechaPago('');
        }
    }, [estado_pago]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFile(file);
        }
    };

    function cerrarModal () {
        setState((prevState) => ({
            ...prevState,
            modalEstadoPago: false,
            cargo_pago: null,
        }));
        setFile(null);
    }; 

return (
    state.modalEstadoPago === true && (<Modal isOpen={state.modalEstadoPago} className="custom-modal" backdrop={true}>
        <ModalHeader className="modal-header">
            <div className="titulo">
                <h1>ACTUALIZAR REGISTRO</h1>
                <Button className="close-btn" onClick={cerrarModal}>X</Button>
            </div>
        </ModalHeader>
    <div className="modal-body-footer">
            {loading ? (
            <Loader />
            ) : (
        <ModalBody className="modal-body">
            <Form>
                <FormGroup className="fila">
                    <label>Apellidos y Nombres:</label>
                    <input 
                        type="text" 
                        value={state.cargo_pago.gestor || ''} 
                        disabled 
                        style={{ backgroundColor: '#f3f4f6', cursor: 'not-allowed' }}
                    />
                </FormGroup>
                <FormGroup className="fila">
                    <label>Importe Neto a Pagar:</label>
                    <input 
                        type="text" 
                        value={(() => {
                            const cp = state.cargo_pago;
                            const produccion  = parseFloat(cp.total_produccion) || 0;
                            const regularizar = parseFloat(cp.monto_regularizar) || 0;
                            const bono_anual  = parseFloat(cp.bono_anual) || 0;
                            const extra       = parseFloat(cp.descuento_extra) || 0;
                            const cancelado   = parseFloat(cp.descuento_cancelados) || 0;
                            const observado   = parseFloat(cp.descuento_documento_observado) || 0;
                            const retencion   = parseFloat(cp.retencion) || 0;
                            const neto = (produccion + regularizar + bono_anual) - (extra + cancelado + observado) - retencion;
                            return new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format(neto);
                        })()} 
                        disabled 
                        style={{ backgroundColor: '#f3f4f6', cursor: 'not-allowed' }}
                    />
                </FormGroup>
                <FormGroup className="fila">
                    <label>Estado de Pago:</label>
                    <select
                        name="estado_pago_id"
                        value={estado_pago || ''}
                        onChange={(e) => setEstadoPago(e.target.value)}
                    >
                        {estados_pago.map((item) => (
                            <option key={item.tipo_id} value={String(item.tipo_id)}>
                                {item.descripcion}
                            </option>
                        ))}
                    </select>
                </FormGroup >



                {estado_pago === '2' && (
                    <FormGroup className="fila">
                        <label>Fecha de Pago:</label>
                        <input
                            type="date"
                            value={fecha_pago}
                            onChange={(e) => setFechaPago(e.target.value)}
                        />
                    </FormGroup>
                )}

                <FormGroup className="fila">
                    <label>Recibo por Honorarios:</label>
                    <div className="cap-upload-zone">
                        <span
                            className="cap-upload-btn"
                            onClick={() => fileRef.current?.click()}
                        >
                            {file ? file.name : 'Seleccionar archivo (PDF)'}
                        </span>
                        <input
                            ref={fileRef}
                            type="file"
                            accept=".pdf"
                            style={{ display: 'none' }}
                            onChange={(e) => setFile(e.target.files[0] || null)}
                        />
                    </div>
                </FormGroup>
                {/* {estado_pago === '4' && (<>
                    <FormGroup className="fila">
                        <label>Monto a pagar (Este periodo):</label>
                        <div>
                            <span className="input-group-text custom-symbol">S/.</span>
                            <input
                                type="number"
                                value={monto_transaccion}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^\d+(\.\d{0,2})?$/;
                                    if (regex.test(value) || value === '') {
                                        setMontoTransaccion(value);
                                    }
                                }}
                            />
                        </div>
                        </FormGroup>
                        <FormGroup className="fila">
                            <label>Factura de pago:</label>
                            <input
                                type="file"
                                accept="application/pdf"
                                onChange={handleFileChange}
                                disabled={parseFloat(monto_transaccion) === 0 || monto_transaccion === ''}
                            />
                        </FormGroup>
                        <FormGroup className="fila">
                            <label>Monto a diferir (Periodo a seleccionar):</label>
                            <div className="input-group custom-input-group">
                            <span className="input-group-text custom-symbol">S/.</span>
                            <input
                                type="number"
                                value={state.cargo_pago.total_pagar - monto_transaccion}
                                disabled
                            />
                            </div>
                        </FormGroup>
                        <FormGroup className="fila">
                            <label>Periodo de pago de monto diferido:</label>
                            <input
                                type="month"
                                value={periodo_pago}
                                onChange={(e) => setPeriodoPago(e.target.value)}
                                disabled={state.cargo_pago.total_pagar - monto_transaccion === 0}
                            />
                        </FormGroup>
                    </>
                )}                  */}
                <div className="button-container">
                    <Button className="button-custom fila" onClick={editarEstadoPago}>
                        ACTUALIZAR
                    </Button>
                </div>
            </Form>
        </ModalBody>)}
        </div>
    </Modal>)
        
    );
}

export default ModalEstadoPago;